// Must match services/auth_service.py's ROLES in admin-backend.
export const ROLES = ['analyst', 'support', 'operator', 'owner'];
